var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import { ENV } from "../../config/env";
import { useToast } from "../../hooks/toast";
import { Header, Input, Button } from "../../components";
import ConectaLogo from "../../assets/logos/conecta-symbol.svg";
import { errorMessage } from "../Login/constants";
import { validationLoginSchema } from "./schema";
import { BoxHelper, Centralize, CentralizeDivider, ColumnHelper, ColumnInput, Container, Content, LinkGoBack, LinkSeeMore, LogoGroup, LogoSymbol, LogoText, Main, Padding, Paragraph, ParagraphHelper, SubTitle, Title, TitleProducthHelper, } from "./styles";
import { useLocation } from "react-router-dom";
var ResetPasswordMigrated = function (props) {
    var document = useLocation().state.document;
    var _a = useToast(), setToast = _a[1];
    var _b = useState({
        email: "",
        loading: false,
        completed: false,
    }), state = _b[0], setState = _b[1];
    var initalFormState = {
        email: "",
    };
    function handleSubmitForm(values) {
        var _a;
        return __awaiter(this, void 0, Promise, function () {
            var data, message, err_1, _b, status, error, message;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        setState(__assign(__assign({}, state), { loading: true }));
                        return [4 /*yield*/, axios.post("".concat(ENV.REGISTER_PATIENT, "/auths/reset-password"), {
                                email: values.email,
                                document: document,
                            })];
                    case 1:
                        data = (_c.sent()).data;
                        message = (data || {}).message;
                        setToast({
                            show: true,
                            type: "info",
                            message: message || "Enviado com sucesso.",
                        });
                        setState(__assign(__assign({}, state), { completed: true, loading: false }));
                        setTimeout(goBack, 5000);
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _c.sent();
                        _b = ((_a = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _a === void 0 ? void 0 : _a.data) || {}, status = _b.status, error = _b.error, message = _b.message;
                        loginErrorTakeAction({ status: status, error: error, message: message });
                        setState(__assign(__assign({}, state), { loading: false }));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    function loginErrorTakeAction(data) {
        var status = data.status, error = data.error, message = data.message;
        message = errorMessage[error] || message;
        // if (error === errorException.GatewayTimeout || status === 504) {
        //   message = errorMessage[errorException.GatewayTimeout];
        // }
        setToast({
            show: true,
            type: "error",
            message: message || errorMessage["default"],
        });
    }
    var formik = useFormik({
        initialValues: initalFormState,
        validateOnBlur: true,
        validateOnChange: true,
        validationSchema: validationLoginSchema,
        onSubmit: function (values) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, handleSubmitForm(values)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        }); }); },
    });
    var handleSubmit = formik.handleSubmit;
    var getError = function (key) {
        return formik.errors[key] && formik.touched[key] && formik.errors[key];
    };
    var getErrorFeedback = function (key) { return ({
        show: !!getError(key),
        text: getError(key),
        variation: "error",
    }); };
    function goHelper() {
        window.location.href = "/support".concat(window.location.search);
    }
    function goBack() {
        window.history && window.history.back();
    }
    return (_jsx(_Fragment, { children: _jsxs(Container, { children: [_jsx(Header, {}), _jsx(Main, { children: _jsxs(Content, { children: [_jsxs(ColumnInput, { children: [_jsx(Title, { children: "Atualiza\u00E7\u00E3o cadastral" }), state.completed ? (_jsxs(React.Fragment, { children: [_jsx("h3", { children: "Email enviado" }), _jsx("p", { children: "Confira sua caixa de e-mail." })] })) : (_jsxs(React.Fragment, { children: [_jsx(Paragraph, { children: "Agora voc\u00EA tem uma nova forma de se autenticar nos produtos digitais do Einstein Conecta, sem a necessidade de criar diversos cadastros Para dar continuidade precisaremos resetar a sua senha, digite o e-mail vinculado a sua conta para receber as instru\u00E7\u00F5es." }), _jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsx(Padding, { children: _jsx(Input, { label: "E-mail", placeholder: "E-mail", type: "text", name: "email", width: "100%", onBlur: formik.handleBlur("email"), feedback: getErrorFeedback("email"), onChange: function (e) {
                                                                return formik.setFieldValue("email", e.target.value);
                                                            }, value: formik.values.email }) }), _jsx(Centralize, { children: _jsx(Button, __assign({ loading: !!state.loading, disabled: Boolean(!formik.values.email || formik.errors.email) }, { children: "Redefinir senha" })) })] })), _jsxs(CentralizeDivider, { children: [_jsx(Padding, __assign({ paddingBottom: 0 }, { children: "Est\u00E1 com dificuldade para redefinir sua senha ou acessar?" })), _jsx(Button, __assign({ variation: "outline", onClick: goHelper }, { children: "Fale com o suporte" }))] })] }))] }), _jsx(ColumnHelper, { children: _jsxs(BoxHelper, { children: [_jsx(SubTitle, { children: "Conhe\u00E7a todos programas e servi\u00E7os disponibilizado ap\u00F3s a atualiza\u00E7\u00E3o de login." }), _jsxs(LogoGroup, { children: [_jsx(LogoSymbol, { children: _jsx("img", { src: ConectaLogo, alt: "Conecta Einstein" }) }), _jsxs(LogoText, { children: ["Acesso \u00FAnico as plataformas ", _jsx("br", {}), _jsx("strong", { children: "Einstein Conecta" })] })] }), _jsx(TitleProducthHelper, { children: "CONECTA" }), _jsx(ParagraphHelper, { children: "Receba orienta\u00E7\u00F5es m\u00E9dicas, receitas e atestados por telemedicina." }), _jsxs(LinkSeeMore, __assign({ href: "https://conecta.einstein.br/", target: "_blank" }, { children: [">", " Saber mais"] })), _jsx(TitleProducthHelper, { children: "PREDICTA" }), _jsx(ParagraphHelper, { children: "Tenha um mapa gen\u00E9tico para monitorar sua sa\u00FAde e prevenir doen\u00E7as." }), _jsxs(LinkSeeMore, __assign({ href: "https://predicta.einstein.br/", target: "_blank" }, { children: [">", " Saber mais"] })), _jsx(TitleProducthHelper, { children: "REABILITA\u00C7\u00C3O" }), _jsx(ParagraphHelper, { children: "Programas com acompanhamento com equipe m\u00E9dica multidisciplinar." }), _jsxs(LinkSeeMore, __assign({ href: "https://www.einstein.br/estrutura/reabilitacao", target: "_blank" }, { children: [">", " Saber mais"] })), _jsxs(LinkGoBack, __assign({ onClick: goBack }, { children: [">", " Voltar para o login"] }))] }) })] }) })] }) }));
};
export default ResetPasswordMigrated;
